// Get padding and fontsize per inputSize
export var getSizeData = function (inputSize) {
    if (inputSize === "large") {
        return {
            padding: "16.5px",
            fontSize: "16px",
            legend: "12px",
            label: "16px",
        };
    }
    if (inputSize === "medium") {
        return {
            padding: "11px",
            fontSize: "16px",
            legend: "12px",
            label: "11px",
        };
    }
    return {
        padding: "8px",
        fontSize: "16px",
        legend: "12px",
        label: "7px",
    };
};
